import React from "react";

const COLORS = ["#a855f7", "#ec4899", "#7dd3fc"];

// A row of echoing monolith silhouettes — carries the hero's 3D pillars into the flat sections
const SectionGate = ({ label, testId }) => {
    return (
        <div
            data-testid={testId}
            className="relative flex flex-col items-center gap-7 overflow-hidden py-12"
            aria-hidden="true"
        >
            <div className="flex items-end gap-3 sm:gap-5">
                {Array.from({ length: 8 }, (_, i) => {
                    const color = COLORS[i % 3];
                    return (
                        <div key={i} className="flex flex-col items-center gap-2.5">
                            <span
                                className="block h-2 w-2 rotate-45"
                                style={{
                                    backgroundColor: color,
                                    boxShadow: `0 0 10px ${color}`,
                                    animation: `pulse-glow 3.2s ease-in-out infinite`,
                                    animationDelay: `${i * 0.35}s`,
                                }}
                            />
                            <span
                                className="block w-1.5 rounded-sm sm:w-2"
                                style={{
                                    height: `${22 + ((i * 37) % 4) * 16}px`,
                                    background: `linear-gradient(to top, ${color}11, ${color}cc)`,
                                    animation: `pulse-glow 3.2s ease-in-out infinite`,
                                    animationDelay: `${i * 0.35}s`,
                                }}
                            />
                        </div>
                    );
                })}
            </div>
            <p className="font-mono-tech text-[10px] uppercase tracking-[0.4em] text-white/30">{label}</p>
        </div>
    );
};

export default SectionGate;
